export default {
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  MY_PROJECTS: '/project/my-projects',
  DELETED_PROJECTS: '/project/deleted-projects',
  PROJECT_REVIEW: '/project/:projectId/review',
  PROJECT_MODE: '/project/edit/:projectId',
  PROJECT_BOARD: '/project/:projectId/edit',
  EDIT_CHART: '/chart/:chartId/edit',
  ADD_CHART: '/chart/:projectId/new',
  CHART_PREVIEW: '/chart/:chartId/:collaborationId/preview',
  PROJECT_PREVIEW: '/project/:projectId/:collaborationId/preview',
  PROJECT_CHART_PREVIEW: '/chart/:chartId/:collaborationId/:projectId/preview',
  PAGE_NOT_FOUND: '/page-not-found',
  MICRO_CLAIM: '/claim'
};
